/* eslint-disable react/prop-types, react/no-unstable-nested-components, react/jsx-no-bind, no-unused-vars, jsx-a11y/control-has-associated-label */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  connectHits,
} from 'react-instantsearch-dom';
import CopyText from '../copy_text';
import Avatar from '../avatar/avatar';
import vahoy from '../../javascript/vahoy';
import { parseLinkedIn, parseX, truncateHandle } from './social_handles';

const ReporterSearchHit = connectHits(({
                                         hits,
                                         toggleReporter,
                                         selectedReporterGids,
                                         selectAllChecked,
                                         setHits,
                                         isAdmin,
                                       }) => {
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  useEffect(() => {
    if (debounceTimeout) clearTimeout(debounceTimeout);

    const newTimeout = setTimeout(() => {
      vahoy.track('media_db_reporters/ReporterSearchHit#agoliaReporterSearch');
    }, 3000);

    setDebounceTimeout(newTimeout);
    return () => clearTimeout(newTimeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hits]); // Dependency array, effect will re-run if `hits` changes

  setHits(hits);

  function formatHashtag(hashtag) {
    // Remove the pound sign
    let formatted = hashtag.replace(/^#/, '');

    // Split camel case into words and join with space
    formatted = formatted.replace(/([a-z])([A-Z])/g, '$1 $2');

    // Convert to lowercase
    return formatted.toLowerCase();
  }

  function formatHashtagList(hashtagList) {
    const str = String(hashtagList);

    // Split the list into an array of hashtags
    const hashtags = str.split(',').map((s) => s.trim());

    // Format each hashtag and join them back into a string
    return hashtags.map(formatHashtag).join(', ');
  }

  function getTruncatedList(input, limit) {
    const str = String(input);

    const elements = str.split(',');
    let result = '';
    let currentLength = 0;

    for (const element of elements) {
      const additionalLength = element.length + (currentLength > 0 ? 1 : 0);
      if (currentLength + additionalLength <= limit) {
        result += (currentLength > 0 ? ', ' : '') + element;
        currentLength += additionalLength;
      } else {
        break;
      }
    }
    return result;
  }

  function emailCopied() {
    vahoy.track('media_db_reporters/ReporterSearchHit#emailCopied');
  }

  function phoneCopied() {
    vahoy.track('media_db_reporters/ReporterSearchHit#phoneCopied');
  }

  return (
    <>
      {hits.map((hit) => {
        const gid = hit.data_source;
        const gidForEmail = `${gid.replace(/[^a-zA-Z0-9-_]/g, '_')}-email`;
        const gidForPhone = `${gid.replace(/[^a-zA-Z0-9-_]/g, '_')}-phone`;

        const charLimit = 80;
        const initials = `${hit.first_name?.charAt(0)}${hit.last_name?.charAt(0)}`;

        // { url, handle } -- handle is null when the stored value yields nothing handle-shaped,
        // and the icon then links on its own with no text beside it. See social_handles.js.
        const linkedIn = parseLinkedIn(hit.linkedin);
        const x = parseX(hit.twitter);

        const regex = /\w+\/([^/]+)\//;
        const match = gid.match(regex);
        const dataSourceType = match ? match[1] : null;

        return (
          <tr key={gidForEmail}>
            <td className="ps-2 d-md-table-cell d-block">
              <div className="d-flex flex-row align-items-center">
                <input
                  type="checkbox"
                  className="form-check-input my-auto d-none d-md-block me-3"
                  checked={selectedReporterGids[gid] || selectAllChecked}
                  onChange={() => toggleReporter(gid)}
                />
                <div className="d-flex flex-column flex-lg-row">
                  <Avatar
                    avatarUrl={hit.headshot_url}
                    sizeClass="avatar-sm"
                    avatarLetters={initials}
                  />
                  <div className="media-db-list-name pt-md-3" style={{ minWidth: '150px' }}>
                    {hit.first_name}&nbsp;{hit.last_name}
                  </div>
                </div>
              </div>
            </td>
            {/* V2 prints the job title under the name in grey; V1 keeps it in its own column,
                so the muted styling goes on the whole cell. */}
            <td className="d-xl-table-cell d-md-none d-block media-db-list-muted">
              {!hit.title && 'reporter'}
              {hit.title && hit.title.length > 0 && (
                <div style={{ width: '125px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {hit.title}
                </div>
              )}
            </td>
            <td className="d-xl-table-cell d-md-none d-block">
              {hit.publications && hit.publications.length > 0 && (
                <div>
                  {getTruncatedList(hit.publications, charLimit)}
                </div>
              )}
            </td>
            <td className="d-md-table-cell d-xl-none d-none">
              {!hit.title && 'reporter'}
              {hit.title && hit.title.length > 0 && (
                <div style={{
 fontWeight: 'bold', width: '125px', overflow: 'hidden', textOverflow: 'ellipsis',
}}
                >
                  {hit.title}
                </div>
              )}
              {hit.publications && hit.publications.length > 0 && (
                <div className="fst-italic">
                  {getTruncatedList(hit.publications, charLimit)}
                </div>
              )}
            </td>
            <td className="d-md-table-cell d-block small">
              {hit.topics && hit.topics.length > 0 && (
                <div>{getTruncatedList(formatHashtagList(hit.topics), charLimit)}</div>
              )}
            </td>
            <td className="d-md-table-cell d-block align-top pb-0 pb-md-2 media-db-list-contact">
              {hit.email && (
                <div className="link-primary overflow-hidden lh-lg" style={{ height: '2em' }}>
                  {/* A long address wraps and the second line is clipped, with no room in the
                      table for an ellipsis. The title carries the whole of it, and the button
                      beside it copies the whole of it. */}
                  <a href={`mailto:${hit.email}`} title={hit.email}>{hit.email}</a>
                  <CopyText
                    successCallback={emailCopied}
                    text={hit.email}
                    tooltipText="Copied!"
                    uniqueId={`obj-${gidForEmail}`}
                  />
                </div>
              )}
              {hit.phone && (
                <div className="link-primary overflow-hidden lh-lg" style={{ height: '2em' }}>
                  <a href={`phone:${hit.phone}`}>{hit.phone}</a>
                  <CopyText
                    successCallback={phoneCopied}
                    text={hit.phone}
                    tooltipText="Copied!"
                    uniqueId={`obj-${gidForPhone}`}
                  />
                </div>
              )}
              {hit.location_string && (
                <div className="link-primary overflow-hidden lh-lg" style={{ height: '2em' }}>
                  <i className="fa-solid fa-location-dot" />
                  &nbsp;
                  {hit.location_string}
                </div>
              )}
            </td>
            <td className="d-md-table-cell d-block align-top pb-0 pb-md-2 pt-0 pt-md-2 media-db-list-handles">
              {x.url && (
                <div className="link-primary overflow-hidden lh-lg mt-0 mt-md-3" style={{ height: '2em' }}>
                  <a
                    href={x.url}
                    aria-label={x.handle ? `${x.handle} on X` : 'X profile'}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa-brands fa-x-twitter" />
                  </a>
                  {/* No handle means the stored value gave us nothing worth printing; the icon
                      links on its own rather than showing a piece of a URL. */}
                  {x.handle && (
                    <>
                      &nbsp;
                      <a
                        href={x.url}
                        className="d-inline d-md-none d-xl-inline"
                        target="_blank"
                        rel="noreferrer"
                        title={x.handle}
                      >
                        {truncateHandle(x.handle)}
                      </a>
                    </>
                  )}
                </div>
              )}
              {linkedIn.url && (
                <div className="link-primary overflow-hidden lh-lg mt-0 mt-md-2 mb-0 mb-md-3" style={{ height: '2em' }}>
                  <a
                    href={linkedIn.url}
                    aria-label={linkedIn.handle ? `${linkedIn.handle} on LinkedIn` : 'LinkedIn profile'}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa-brands fa-linkedin" />
                  </a>
                  {linkedIn.handle && (
                  <a
                    href={linkedIn.url}
                    className="d-inline d-md-none d-xl-inline ms-2"
                    target="_blank"
                    rel="noreferrer"
                    title={linkedIn.handle}
                  >
                    {truncateHandle(linkedIn.handle)}
                  </a>
                  )}
                </div>
              )}
            </td>
            {isAdmin && (
              <td className="d-md-table-cell d-block">
                {dataSourceType === 'MediaDbReporter' && (
                  <>
                    <a
                      className="btn btn-sm btn-staff mb-md-1 me-1"
                      href={`/media_db_reporters/${gid.split('/').pop()}/edit`}
                      rel="noreferrer"
                    >
                      Edit
                    </a>
                    {!hit.visible && (
                      <a
                        className="btn btn-sm btn-staff"
                        href={`/media_db_reporters/${gid.split('/').pop()}/hide?visible=true`}
                        rel="noreferrer"
                      >
                        Unhide
                      </a>
                    )}
                    {hit.visible && (
                      <a
                        className="btn btn-sm btn-staff"
                        href={`/media_db_reporters/${gid.split('/').pop()}/hide?visible=false`}
                        rel="noreferrer"
                      >
                        Hide
                      </a>
                    )}
                  </>
                )}
                {dataSourceType === 'Reporter' && (
                  <>
                    <a
                      className="btn btn-sm btn-staff"
                      href={`/reporters/${gid.split('/').pop()}`}
                      rel="noreferrer"
                    >
                      Reporter profile
                    </a>
                  </>
                )}
              </td>
            )}
          </tr>
        );
      })}
    </>
  );
});

export default ReporterSearchHit;
/* eslint-enable react/prop-types, react/no-unstable-nested-components, react/jsx-no-bind, no-unused-vars */
